import React from "react";
import eventImage from "assets/images/common/others/exploreEvents.png";
import HostImage from "assets/images/common/others/attende1.png";
import { ReactComponent as ReviewGolden } from "assets/images/common/svgs/reviewGolden.svg";
import eventBadge from "assets/images/common/others/eventBadge.png";
import dummyImage from "assets/images/common/others/minorImage.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  eventData: any;
}

const EventDetail = ({ eventData }: Props) => {
  return (
    <div className="w-full lg:w-[750px]">
      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Learning Activity
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.description || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Core Concepts
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.coreConcept
              ?.map((concept: any) =>
                concept
                  .toLowerCase()
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (char: any) => char.toUpperCase())
              )
              .join(", ")}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Parent Supervision
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.parentSupervision === true
              ? "Yes"
              : eventData?.event?.parentSupervision === false
              ? "No"
              : "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">
            Special Instructions
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.specialInstructions || "-"}
          </span>
        </div>
      </div>

      <div className="mt-8 flex flex-wrap justify-between items-center gap-4">
        <div className="flex flex-col gap-4 max-w-60">
          <span className="text-sm font-semibold text-captionText">
            Physical Consideration
          </span>
          <span className="text-xs text-tertiaryText">
            {eventData?.event?.physicalConsideration || "-"}
          </span>
        </div>
        <div className="flex flex-col gap-4 ">
          <span className="text-sm font-semibold text-captionText">
            Digital Badge
          </span>
          <span className="">
            <img
              className="w-[60px] h-[60px] "
              src={
                eventData?.event
                  ? concatPathWithBackendUrl(
                    eventData?.event?.eventBadge?.image?.name
                  )
                  : ""
              }
              // src={
              //   eventData?.event?.profilePicUrl
              //     ? concatPathWithBackendUrl(
              //         eventData?.rsvp?.profilePicUrl.fileDownloadUri
              //       )
              //     : ""
              // }
              alt="eventBadge"
            />
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <span className="text-sm font-semibold text-captionText">RSVP</span>
          <span className="flex gap-3 items-center">
            <img
              className="w-10 h-10 rounded-full"
              src={
                eventData?.rsvp?.profilePicUrl
                  ? concatPathWithBackendUrl(
                      eventData?.rsvp?.profilePicUrl.fileDownloadUri
                    )
                  : ""
              }
              alt="dummyImage"
            />
            <p className="text-base font-bold text-primaryText">
              {eventData?.rsvp?.firstName || "-"}{" "}
              {eventData?.rsvp?.lastName || ""}
            </p>
          </span>
        </div>
      </div>

      <div className="flex flex-col gap-4 mt-8">
        <span className="text-sm font-semibold text-captionText">Host</span>
        <div className="border boder-lightGrayBorder rounded-lg p-3 w-[180px] flex flex-col items-center justify-center">
          <span>
            <img
              className="w-[100px] h-[100px] rounded-full "
              src={
                eventData?.host?.profilePicUrl
                  ? concatPathWithBackendUrl(
                      eventData?.host?.profilePicUrl.fileDownloadUri
                    )
                  : ""
              }
              alt="HostImage"
            />
          </span>
          <p className="font-bold text-base text-primaryText my-1">
            {eventData?.host?.firstName || "-"}{" "}
            {eventData?.host?.lastName || ""}
          </p>
          <span className="flex gap-1">
            <ReviewGolden />
            <p className="text-xs text-primaryText">{eventData?.host?.avgRating || 0}</p>
          </span>
        </div>
      </div>
    </div>
  );
};

export default EventDetail;
